"use client";

import { routing } from "@/i18n/routing";
import { redirect, usePathname } from "next/navigation";

export default function NotFound() {
  const pathname = usePathname();

  // Add a locale prefix to show a localized not found page
  redirect(`/${routing.defaultLocale}${pathname}`);
}
